import { API_BASE_URL } from "../constant";

export const getAllAdmin = () => API_BASE_URL.get("admin");
export const getAdminById = () => API_BASE_URL.get("admin/user");
export const updateAdmin = (data, adminId) =>
  API_BASE_URL.patch(`admin/${adminId}`, data);
export const deleteAdmin = (userId) =>
  API_BASE_URL.delete(`admin/${userId}`);
